<form [formGroup]="formData" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <!-- <label for="" [translate]="'TITLES.VARIANT_NAME'">Variant Name</label>
			<input type="text" autofocus="true" required="true" formControlName="variant_name" class="form-control">
			<control-messages [submitted]="submitted" [control]="formData.controls.variant_name">
			</control-messages> -->
      <label for="" [translate]="'TITLES.VARIANT_NAME'">Variant Name</label>
      <ng-select
        bindLabel="name"
        bindValue="name"
        formControlName="variant_name"
        [items]="variantTypes"
        [multiple]="false"
        [trackByFn]="trackByFn"
        appendTo="body"
        [clearable]="false"
        name="variantName"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          {{ item.name }}
        </ng-template>
      </ng-select>
      <control-messages
        [submitted]="submitted"
        [control]="formData.controls.variant_name"
      ></control-messages>
    </div>

    <fieldset formArrayName="variant_terms">
      <button
        class="btn btn-brand btn-sm btn-round pull-right mb-2"
        type="button"
        (click)="addVariant()"
        [translate]="'BUTTONS.ADD_TERM'"
      >
        Add Term
      </button>
      <label for="" [translate]="'TITLES.VARIANT_TERMS'">Variant Terms</label>
      <table class="table table-striped table-hover">
        <tbody>
          <tr
            *ngFor="
              let term of formData['controls'].variant_terms['controls'];
              let idx = index
            "
          >
            <td>
              <input
                type="text"
                id="{{ 'term' + idx }}"
                name="{{ 'term' + idx }}"
                [formControlName]="idx"
                class="form-control"
                (keydown.enter)="addVariant(idx + 1)"
              />
            </td>
            <td
              width="60"
              class="actions text-center valign-middle"
              valign="middle"
            >
              <a
                href="javascript:;"
                (click)="formData['controls'].variant_terms.removeAt(idx)"
                class="text-danger"
                title="Remove"
              >
                <i class="fas fa-trash fa-fw"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close</button
    >
    <button
      type="button"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success"
      (click)="submit()"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save
    </button>
  </div>
</form>
